import c from "../../utils/constants";
import moment from "moment";
import env from "../../utils/env";

class BusinessesController {
  constructor(BusinessesService, FilterService, AuthService, $scope) {
    "ngInject"

    this.businessesService = BusinessesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions()
  }

  $onInit() {
    const dataSource = [];
    Object.keys(c.locationStatus).forEach((key) => {
      const value = c.locationStatus[key];
      if (value === 0)
        return;

      dataSource.push({
        value,
        text: c.getLocationStatusText(value),
      });
    });
    this.businessStatusOptions = {
      dataSource,
      dataTextField: "text",
      dataValueField: "value",
    }
  }

  getGridOptions() {
    return {
      dataSource: this.businessesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        { field: "id", title: "ID", filterable: false, width: "3rem" },
        {
          field: "name", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "6rem",
          template: (dataItem) => `<a class="cell" href="/businesses/${dataItem.id}"><span>${dataItem.name}</span></a>`,
        },
        {
          field: "name", title: "Landing Page", filterable: false, attributes: {"class": "col-name"}, width: "4rem",
          template: (dataItem) => `<a target="_blank" class="cell" href="https://www.jugglestreet.com.au/business-details?businessId=${dataItem.id}"><span>Search results</span></a>`,
        },
        // {
        //   field: "jugglerId", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "12rem",
        //   template: (dataItem) => `<a class="cell" href="/users/${dataItem.userId}"><div class="image-container"><img src="${dataItem.imageUrl ? this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png"}"></img></div><span>${dataItem.fullName}</span></a>`,
        // },
        // {
        //   field: "email", title: "Email", filterable: false, width: "15rem",
        //   template: `<a href="mailto:#= email #">#= email #</a>`
        // },
        // { field: "address", title: "Address", filterable: false, width: "8rem" },
        { field: "locationType", title: "Type", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getBusinessType(dataItem.locationType)}` },
        { field: "helpersCount", title: "Helpers Count", filterable: false, width: "2rem" },
        { field: "locationStatus", title: "Lead Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getBusinessStatus(dataItem.locationStatus)}` },
        // { field: "addressState", title: "State", filterable: false, width: "8rem" },
        // { field: "addressPostCode", title: "Postcode", filterable: false, width: "8rem" },
        // {
        //   field: "updatedAt", title: "Updated At", filterable: false, width: "6rem",
        //   template: `<span>#= kendo.toString(new Date(updatedAt ? updatedAt : createdAt), 'dd/MM @hh:mmtt') #</span>`,
        // },
        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update Business" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  saveChanges(e) {
    // const check = e.model;

    // if ((check.visaCheckStatus == 2) && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
    //   this.notificationService.error("Check missing fields and try again.");
    //   e.preventDefault();
    // }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.businessesMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getBusinessStatus(status) {
    return c.getLocationStatusText(status);
  }

  _getBusinessType(type) {
    return c.getLocationTypeText(type);
  }
}

export default BusinessesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/businesses/businesses.controller.js
 **/